import React from 'react';
import SearchAndSelect, { MultiSearchAndSelectProp } from '../base';
import { ProductListOptions } from '~/api';
import { useTranslate } from '@refinedev/core';

type Props = Omit<MultiSearchAndSelectProp, 'queryKey'> & {
  isWithName?: boolean;
  onSelect?: (id: string) => void;
};

export const MultiProductSelection: React.FC<Props> = (props) => {
  const { onSelect, isWithName, ...restProps } = props;
  const t = useTranslate();

  return (
    <SearchAndSelect
      {...restProps}
      onSelect={(id) => onSelect?.(id)}
      queryKey="getProducts"
      getValueAndLabel={({ id, name }) => {
        let label = `${name}`.trim();
        return {
          value: isWithName ? `${id}-split-${label}` : `${id}`,
          label: label,
        };
      }}
      variables={{
        options: {
          filter: { type: { eq: 'PRODUCT' }, enabled: { eq: true } },
        } as ProductListOptions,
      }}
      placeholder={t('placeholder.search.product')}
    />
  );
};

export type ProductSelectionProps = Props;
